import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { FallAufgabenStatus, TeilaufgabenSolution } from '@reflact/ipkv-types';
import { Api } from './api';

export const solutionsResolver: ResolveFn<void> = async (route, state) => {
  const api = inject(Api);
  return await api.getCurrentSolutions();
}